import {
  registerCustomDetailComponent,
  registerFormInputComponent,
} from "@bb-vendure/admin-ui/core";
import FreeGiftToggleComponent from "./components/FreeGiftsNg/Toggle/toggle.component";
import FreeGiftComponent from "./components/FreeGiftsNg/gifts.component";
import VariantFreeGiftListComponent from "./components/variant-free-gift-list/variant-free-gift-list.component";

export default [
  registerCustomDetailComponent({
    locationId: "product-detail",
    component: VariantFreeGiftListComponent,
  }),
  registerFormInputComponent("toggle-form-input", FreeGiftToggleComponent),
];
